import React from 'react'
import { styled } from '@mui/system';
import { TextField } from "@mui/material";
import { Box } from '@mui/system';


const Contain = styled("div")({
    // marginRight: "20px",
    // marginLeft: "25px",
    marginTop: "10px",

});

const ItemHeading = styled("div")({
    // marginLeft: "25px",
    marginTop: '20px',
    color: "#717171",
    fontSize: "16px",
    fontFamily: "Arial"
});

const Tf = styled('div')({
    fontSize: '13x',
    backgroundColor: "#f8f8f8",
    borderRadius: "5px",
    "& .MuiInputBase-input": {
        color: "#333333",
        fontSize: "14px",
        fontFamily: "arial",
        fontWeight: "400",
        textTransform: "none",
        // padding: "4px",
        textAlign: "left"
    },
});

const ReviewerRejectionReasonEdit = (props: any) => {
    const { setMoveTab, setNavPrompt, reviewerRejectionReason, setReviewerRejectionReason, disableTextAfterSubmission, employeeDataIsFetching, employeeDataIsLoading } = props;

    const handleReviewerRejectionReasonChange = (e: any) => {
        setReviewerRejectionReason(e.target.value)
    }
    return (
        <>
            <div>
                <ItemHeading>
                    <b>Reviewer Rejection Reason</b><span style={{
                        fontSize: "22px",
                    }}>*</span>
                </ItemHeading>


                <Contain>
                    <Box>
                        <Tf>
                            <TextField
                                InputProps={{ readOnly: disableTextAfterSubmission }}
                                disabled={disableTextAfterSubmission || employeeDataIsFetching || employeeDataIsLoading}
                                fullWidth
                                multiline
                                // inputProps={{ maxLength: 500 }}
                                placeholder='Add'
                                size='small'
                                name="comments"
                                value={reviewerRejectionReason}
                                onChange={e => {
                                    handleReviewerRejectionReasonChange(e);
                                    setMoveTab(true);
                                    setNavPrompt(true);
                                }}
                            />
                        </Tf>
                    </Box>
                </Contain>
            </div>
        </>)
}

export default ReviewerRejectionReasonEdit